<template>
  <div class="">
    <div class="" v-if="loading">
      <!-- Show the loader when async operation is going on -->
      <div class="loader"></div>
    </div>
    <perfect-scrollbar class="scroll-area-modal" v-else >
      <div class="mt-10 ml-10">
        <span class="font-weight-bold">Filter By:</span>
        <span v-for="(row, index) in filters" :key="index" class="font-weight-bold badge p-2 ml-15 make-cursor-pointer" :class="selectedFilter === row.key ? 'badge-pill badge-success' : 'badge-pill badge-light'" @click="selectedFilter = row.key">
        {{row.displayName}}
      </span>
      </div>
      <table class="table table-striped single-outage-table">
        <thead>
        <tr>
          <th width="50%" class='text-left' scope="col">Task Name</th>
          <th class='text-center' scope="col">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="value in allPendingTask" :key="value.id">
          <td width="50%">
            <div class="d-flex align-items-center">
              <div class='image-container pl-0 ml-0 mr-0'>
                <img v-if="value.taskTypes==='sales Task' || value.taskTypes==='Manual sales Task'" width="70%"  src="../../../assets/img/sales.png" alt="Task Image">
                <img v-else-if="value.taskTypes==='support Task' || value.taskTypes==='Manual support Task'" width="45%"  src="../../../assets/img/support.svg" alt="Task Image">
                <img v-else-if="value.taskTypes==='migration Task'" width="50%"   src="../../../assets/img/migration.png" alt="Task Image">
              </div>
              <div class=""><span class="text-capitalize">{{ value.taskTypes }}</span> - {{domainAdjustmentForActiveTask(value.domain)}}</div></div>
          </td>
          <td class="text-center">
            <button  class="btn btn-primary btn-sm mr-2" @click="checkInTask(value)">
              <div class="loader mini_loader" v-if="selectedId === value.id && action === 'checkin'" disabled="isLoading"></div>
              <span> checkin</span>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </perfect-scrollbar >
    <div v-if="allPendingTask && allPendingTask.length === 0 && !loading">  <p class="hm300 card-text text-center text-danger mb-3 font-weight-bold">No data found.</p></div>
  </div>
</template>

<script>
import statisticsMixin from "@/mixins/statisticsMixin";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "PendingTasks",
  mixins: [statisticsMixin],
  props: {
    getAllActiveTasks: {
      type: Function,
      required: true
    },
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    pendingSalesTasks() {
      const result = this.$store.getters['tasks/getActiveSalesTasks'];
      const filteredResults = [];
      for (const value of result) {
        if (!value.checkinBy ||  value.checkinBy === '') {
          filteredResults.push({ id: value.docId, taskTypes: 'sales Task', type: 'sales', ...value });
        }
        if (filteredResults.length >= 10) {
          break;
        }
      }

      return filteredResults;

    },
    pendingSupportTasks () {
      const {urgent}= this.$store.getters['tasks/getActiveSupportTasks'];
      const filteredResults = [];
      for (const value of urgent) {
        if (!value.checkinBy || value.checkinBy === '') {
          filteredResults.push({ id: value.docId, taskTypes: 'support Task', type: 'support', ...value });
        }
        if (filteredResults.length >= 10) {
          break;
        }
      }

      return filteredResults;

    },
    pendingMigrations() {
      let new_array = this.$store.getters["tasks/getActiveMigrations"];
      new_array = new_array.sort(
          (a, b) => new Date(b.created) - new Date(a.created)
      );
      const filteredResults = [];
      for (const value of new_array) {
        if (value.handledBy === '' || !value.handledBy) {
          filteredResults.push({ id: value.docId, taskTypes: 'migration Task', domain: value.siteDetails.domainName, type: 'migration', ...value });
        }
        if (filteredResults.length >= 10) {
          break;
        }
      }
      return filteredResults;
    },
    allPendingTask(){
      if(this.selectedFilter=== 'support'){
        return [...this.pendingManualSupportTaskList  ,...this.pendingSupportTasks, ...this.pendingMigrations ]
      }
      else{
        return [...this.pendingManualSupportTaskList, ...this.pendingManualSalesTaskList , ...this.pendingSalesTasks , ...this.pendingSupportTasks, ...this.pendingMigrations ]
      }
    }
  },
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      filters: [
        { key: 'support', displayName: 'Support' },
        { key: 'sales', displayName: 'Sales'  },
      ],
      selectedFilter :'support',
      pendingTaskList: [],
      pendingManualSupportTaskList: [],
      pendingManualSalesTaskList: [],
      loading: true,
      action: 'none',
      selectedId : null,
      pendingJobListener: null,
      isLoading: false,
    }
  },
  beforeDestroyed(){
    if (this.pendingJobListener) {
      this.pendingJobListener();
    }
  },
  methods: {
    async checkInTask(value){
      console.log('task type', value.taskTypes);
      const {taskTypes} = value;
      // for Manual sales & support
      if(taskTypes === 'Manual support Task' || taskTypes === 'Manual sales Task'){
        await this.checkInManualTask(value);
      }
     else if (taskTypes==='sales Task' ||  taskTypes==='support Task'){
       await this.checkinSalesAndSupportTask(value);
     }
     else if(taskTypes=== 'migration Task'){
       await this.checkInMigration(value)
      }
      swal('Success!', 'Task has been checked in!', 'success');
      this.isLoading= false;
      await this.getAllActiveTasks();
    },
    async checkInMigration(value) {
      this.selectedIndex = value.id;
      this.action = 'checkin'
      await db.collection('savedMigrations').doc(value.docId).update({
        handledBy: this.user.firstName + ' ' + this.user.lastName,
        modified: new Date().toISOString()
      })
      this.addLog({
        message: "Checking in migration",
        level: "info"
      })
      if (value.ticketId) {
        try {
          await this.$http.post('/host-bill/add-ticket-tag', {
            ticketId: value.ticketId,
            grant_type: 'token',
            tag: `${this.user.firstName} ${this.user.lastName}`
          })
          await this.$http.post('/host-bill/update-ticket-status', {
            ticketNumber: value.ticketId,
            grant_type: 'token',
            status: 'In-Progress',
            fromMigration: true
          })

        } catch (e) {
          console.log(e.toString())
        }

        this.selectedIndex = '';
        this.action = ''
      }
      try {
        const msg = `*${this.user.firstName}* *${this.user.lastName}* has checked into migration: ${value.siteDetails.domainName}.`
        await this.$http.post('utilities/send-slack-notification', {
          grant_type: 'token',
          msg,
          showButton: false,
        });
      } catch (e) {
        console.log(e.toString());
      }
      const domain = value.domainDetails.domainRegistrarDetails.domainName;
      const data= {
        ticketId: value.ticketId,
        taskId: value.docId,
        type  : 'info',
        actionType: 'Migration Task',
        message: `Migration for domain ${this.domainAdjustment(domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
        customer: {
          email: value.email,
          domain: domain,
        }
      }
      await this.addRecentActivity({...data});
      await this.addToAdminActiveTask({...data});
    },
    async checkinSalesAndSupportTask (task) {
      try {
        this.selectedIndex = task.id;
        this.action = 'checkin'
        const ref = await db.collection('bigScootsTasks').doc(task.docId).get();
        if (ref.exists) {
          await db.collection('bigScootsTasks').doc(task.docId).update({checkinBy: `${this.user.firstName} ${this.user.lastName}`});
          task.checkinBy = `${this.user.firstName} ${this.user.lastName}`;
        }
        if (task.ticketID) {
          try {
            await this.$http.post('/host-bill/add-ticket-tag', {
              ticketId: task.ticketID,
              grant_type: 'token',
              tag: `${this.user.firstName} ${this.user.lastName}`
            })
            await this.$http.post('/host-bill/update-ticket-status', {
              ticketNumber: task.ticketID,
              grant_type: 'token',
              status: 'In-Progress'
            })
          } catch (e) {
            console.log(e.toString())
          }
        }
        const email = task.email ? task.email : null;
        const domain = task.domain ? task.domain : null;
        const message = domain !== null ?
            `${task.type === 'sales' ? 'Sales' : 'Support'} task for domain ${this.domainAdjustment(task.domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`
            :
            `${task.type === 'sales' ? 'Sales' : 'Support'} task has been checked in by ${this.user.firstName} ${this.user.lastName}.`
        const data = {
          taskId: task.docId,
          ticketId: task.ticketID ? task.ticketID : null,
          type  : 'info',
          actionType: `${task.type} Task`,
          message: message,
          customer: {
            email: email,
            domain: task.domain
          }
        };
        await this.addRecentActivity({...data})
        await this.addToAdminActiveTask({...data , text: task.text , ip: task.ip, hbDocId: task.hbDocId });
        // swal('Success', 'You have successfully checked in!', 'success');
      } catch (e) {
        console.log('error from checkin function ==> ', e.toString())
        swal('Error', 'Something went wrong while checkin!', 'error');
      } finally {
        this.selectedIndex = -1;
        this.action = null
      }
    },
    async checkInManualTask(task){
      try{
        this.selectedId=task.id;
        this.action = 'checkin'
        await db.collection('manualTasks').doc(task.id).update({ checkinBy: `${this.user.firstName} ${this.user.lastName}`, checkinByEmail: this.user.email});
        const data= {
          taskId: task.id,
          ticketId: null,
          type  : 'info',
          actionType: `Manual ${task.type} Task`,
          message: `Manual ${task.type} task for domain ${this.domainAdjustment(task.domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
          customer: {
            email: task.hostBillID,
            domain: task.domain,
          }}
        await this.addRecentActivity({...data})
        await this.addToAdminActiveTask({...data})
        try {
          await this.$http.post('/utilities/update_manual_task_to_slack', {
            grant_type: 'token',
            ...task,
            checkinBy: `${this.user.firstName} ${this.user.lastName}`,
            checkinByEmail: this.user.email
          });
        } catch (e) {
          console.log('error from updating manual task', e.toString())
        }
      }
      catch(e){
        console.log(e.toString())
      }
      finally {
        this.selectedId=null;
        this.action = null
      }

      // try {
      //   await this.$http.post('/utilities/update_manual_task_to_slack', {
      //     grant_type: 'token',
      //     ...task,
      //     checkinBy: `${this.user.firstName} ${this.user.lastName}`,
      //     checkinByEmail: this.user.email
      //   });
      // } catch (e) {
      //   console.log('error from updating manual task', e.toString())
      // }
      // finally {
      //   this.selectedId=null;
      //   this.action = null
      // }
    },
    openTicket(ticketNo) {
      window.open(`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&num=${ticketNo}`, '_blank')
    },
    domainAdjustmentForActiveTask(value){
      if(value){
        return value.length > 40 ? `${value.slice(0,40)}...` : value
      }
    },
    async getAllManualActiveTasks(){
      try{
        const manualTaskRef = await db.collection('manualTasks').where('resolved', '==', false).orderBy('createdAt', 'desc').limit(20);
        if(!this.pendingJobListener){
          this.pendingJobListener = manualTaskRef.onSnapshot(snapshot => {
            snapshot.docChanges().forEach((change) => {
              if (change.type === 'added' ) {
                if((!change.doc.data().checkinBy || change.doc.data().checkinBy=== '') && change.doc.data().type==="support"){
                  this.pendingManualSupportTaskList.push({id: change.doc.id,  taskTypes: `Manual ${change.doc.data().type} Task` , type: change.doc.data().type, ...change.doc.data()})
                }
                else if((!change.doc.data().checkinBy || change.doc.data().checkinBy=== '')  && change.doc.data().type==="sales"){
                  this.pendingManualSalesTaskList.push({id: change.doc.id,  taskTypes: `Manual ${change.doc.data().type} Task` , type: change.doc.data().type, ...change.doc.data()})
                }
              }
              else if (change.type === 'modified' || change.type === 'removed') {
                if(change.doc.data().type==="support"){
                  this.pendingManualSupportTaskList = this.pendingManualSupportTaskList.filter(el => el.id !== change.doc.id)
                }
                else if(change.doc.data().type==="sales"){
                  this.pendingManualSalesTaskList = this.pendingManualSalesTaskList.filter(el => el.id !== change.doc.id)
                }
              }
            })
          });
        }
      }
      catch(e){
        console.log(e, 'Error in fetching active tasks')
      }
      finally {
        this.loading= false;
        console.table(this.pendingManualSupportTaskList, 'checkin')
      }
    },
  },
  mounted() {
    this.getAllManualActiveTasks()
  }
}
</script>

<style scoped>
.image-container {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Style the image inside the container */
.image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  mix-blend-mode: multiply;
}
.scroll-area-modal {
  position: relative;
  max-height: 350px;
  overflow: hidden;
}
th{
  font-weight: bold !important;
}
</style>
